module.exports = __webpack_public_path__ + "img/14.01d8712.png";